import { Skeleton, Flex, theme } from '@robinpowered/ui-kit';
import styled from '@emotion/styled';

const SKELETON_STYLE = { opacity: 0.1 };

const SkeletonMenuItem = ({
  width,
  collapsed,
}: {
  width: number;
  collapsed: boolean;
}): JSX.Element => (
  <Flex
    align="center"
    justify={collapsed ? 'center' : 'flex-start'}
    gap={collapsed ? 0 : 8}
    style={{ padding: '8px 12px' }}
  >
    <Skeleton.Avatar active size={16} shape="square" style={SKELETON_STYLE} />
    {!collapsed && (
      <Skeleton.Input
        active
        style={{ ...SKELETON_STYLE, width, minWidth: width, height: 16 }}
      />
    )}
  </Flex>
);

export const MenuSkeleton = ({
  collapsed,
}: {
  collapsed: boolean;
}): JSX.Element => {
  const { useToken } = theme;
  const { token } = useToken();

  return (
    <Container gap={token.marginSM} marginTop={token.marginSM}>
      <SkeletonMenuItem width={32} collapsed={collapsed} />
      <SkeletonMenuItem width={60} collapsed={collapsed} />
      <SkeletonMenuItem width={42} collapsed={collapsed} />
      <SkeletonMenuItem width={102} collapsed={collapsed} />
      <SkeletonMenuItem width={78} collapsed={collapsed} />
      <SkeletonMenuItem width={126} collapsed={collapsed} />
      <SkeletonMenuItem width={66} collapsed={collapsed} />
      <SkeletonMenuItem width={66} collapsed={collapsed} />
    </Container>
  );
};

export const BottomMenuSkeleton = ({
  collapsed,
}: {
  collapsed: boolean;
}): JSX.Element => {
  const { useToken } = theme;
  const { token } = useToken();

  return (
    <BottomContainer
      gap={token.marginSM}
      marginBottom={token.marginSM}
      collapsed={collapsed}
    >
      <SkeletonMenuItem width={56} collapsed={collapsed} />
      <SkeletonMenuItem width={70} collapsed={collapsed} />
      <SkeletonMenuItem width={90} collapsed={collapsed} />
      <SkeletonMenuItem width={90} collapsed={collapsed} />
    </BottomContainer>
  );
};

const Container = styled.div<{ gap: number; marginTop: number }>`
  flex: 1;
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  gap: ${({ gap }) => gap}px;
  margin-top: ${({ marginTop }) => marginTop}px;
`;

const BottomContainer = styled.div<{
  gap: number;
  marginBottom: number;
  collapsed: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: ${({ collapsed }) => (collapsed ? '0' : '0 16px')};
  gap: ${({ gap }) => gap}px;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
`;
